import React from 'react';
import PropTypes from 'prop-types';

import ArrowIcon from '../Iconoclast/ArrowIcon';
import DoubleArrowIcon from '../../assets/images/arrow-double.svg';
import colors from '../../assets/styles/globals.scss';
import i18n from '../../i18n';
import './DashboardMetricCard.scss';

export default class DashboardMetricCard extends React.Component {

  constructor(props) {
    super(props);
    DashboardMetricCard.propTypes = {
      title: PropTypes.string,
      previousMetricValue: PropTypes.number,
      currentMetricValue: PropTypes.number,
      /** can be either 'number' or 'percent' */
      valueType: PropTypes.string,
    };
  }

  getPercentChangeArrow(percentChange) {
    if (percentChange > 0) {
      return <ArrowIcon/>; // up arrow
    }
    else if (percentChange < 0) {
      return <ArrowIcon direction='down'/>; // down arrow
    }
    else return <img src={DoubleArrowIcon} alt='no change arrow'/>; // left and right arrow
  }

  render() {
    const {
      title, 
      previousMetricValue, 
      currentMetricValue, 
      valueType,
    } = this.props;

    let percentChange;
    if (!currentMetricValue || !previousMetricValue || (currentMetricValue == 0 && previousMetricValue == 0)) {
      // both values are zero
      percentChange = 0;
    }
    else if (currentMetricValue * previousMetricValue == 0) {
      // display +/- 100% change for 0 -> any value or any value -> 0
      percentChange = (currentMetricValue > previousMetricValue) ? 100 : -100;
    }
    else {
      percentChange = Math.round(((currentMetricValue - previousMetricValue) / previousMetricValue) * 100);
    }

    const rightSideColor = percentChange < 0 ? colors.red : colors.aoDarkBlue;
    const valueToDisplay = valueType == 'percent' ? Math.round(currentMetricValue * 100) : currentMetricValue;
    return (
      <div className='metric-card'>
        <span className='metric-card__left-side'>
          <h2 className='title'>{title}</h2>
          <p className='percent-change'>
            <span className='percent-change__text'>{i18n.tr('user_dashboard:vs_this_time_last_week')}&nbsp;</span>
            <span className='percent-change__value'>
              <span className='percent-change-arrow'>{this.getPercentChangeArrow(percentChange)}</span>
              <span>{' ' + Math.abs(percentChange) + '%'}</span>
            </span> 
          </p>
        </span>
        <span className='metric-card__right-side' style={ { backgroundColor: rightSideColor } }>
          <span className='metric-value'>{valueToDisplay}</span>
          {
            valueType == 'percent' &&
            <span className='percent-symbol'>%</span>
          }
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DashboardMetricCard/index.js